<lib-page-layout>
  <lib-title-navbar pageHeader title="Edytuj grupkę"></lib-title-navbar>

  <div>
    <form [formGroup]="teamNameForm" class="or-d-flex or-flex-col or-justify-content-center or-mx-24-px or-mt-24-px">
      <div class="or-head-xs or-color-secondary-2 or-mb-4-px">Nazwa grupki</div>
      <input
        class="outline-none input-style or-mb-12-px"
        formControlName="teamName"
        [class.error-field]="isFieldInvalid('teamName')" />
      @if (isNameOverAvailableLength()) {
        <div class="or-mb-12-px or-text-sm or-color-red or-mt-2-px">Maksymalna długość to 25 znaków</div>
      }

      <div class="or-color-secondary-2 or-note-sm or-text-align-center">
        Nazwa grupki będzie również nazwą Waszego chatu. Znajdziesz go w zakładce "Wiadomości"
      </div>
    </form>
  </div>
  <lib-page-actions pageActions>
    <button
      [disabled]="!teamNameForm.valid"
      (click)="saveData()"
      class="button-primary-style or-h-48-px or-w-100-pc or-head-md"
      [class.disabled-button]="!teamNameForm.valid">
      Edytuj grupkę
    </button>
  </lib-page-actions>
</lib-page-layout>
